import React from 'react'
import './Pricing.css';

const PricingSection = () => {
  return (
    <div className="pricingSection">
      <div className='pricingInfo'>
          <div className='pricingItem'>
              <div className='pricingItemTitle'>Basic</div>
              <div className='pStars '>✦</div>
              <div className='pPrice'>Free</div>
              <div className='pDetail'>14-day trial</div>

              <div className='pDivider'></div>

              <div className='pItem'>Support</div>
              <div className='pDetail'> FAQ / Docs</div>

              <div className='pItem'>100</div>
              <div className='pDetail'>Daily Requests</div>

              <div className='pItem'>End-of-day</div>
              <div className='pDetail'>Price data</div>

              <div className='pItem'>1 year</div>
              <div className='pDetail'>Data history</div>

              <button className='priceButton pwhite'>Get Started -></button>
              
          </div>
          <div className='pricingItem'>
              <div className='pricingItemTitle'>Premium</div>
              <div className='pStars green'>✦✦</div>
              <div className='pPrice'>$199</div>
              <div className='pDetail'>per month</div>
              <div className='pDivider'></div>

              <div className='pItem'>Support</div>
              <div className='pDetail'>Email</div>

              <div className='pItem'>10,000</div>
              <div className='pDetail'>Daily Requests</div>

              <div className='pItem'>15 minute</div>
              <div className='pDetail'>Price data</div>

              <div className='pItem'>5 year</div>
              <div className='pDetail'>Data history</div>

              <button className='priceButton pgreen'>Sign up -></button>
          </div>
          <div className='pricingItem'>
              <div className='pricingItemTitle'>Enterprise</div>
              <div className='pStars gold'>✦✦✦</div>
              <div className='pPrice'>Custom Plan</div>
              <div className='pDetail'>Contact sales</div>
              <div className='pDivider'></div>

              <div className='pItem'>Support</div>
              <div className='pDetail'>Priority Email</div>

              <div className='pItem'>Unlimited</div>
              <div className='pDetail'>Daily Requests</div>

              <div className='pItem'>Realtime</div>
              <div className='pDetail'>Price data</div>

              <div className='pItem'>Full</div>
              <div className='pDetail'>Data history</div>

              <button className='priceButton pblack'>Get a quote -></button>
          </div>

      </div>
    </div>
  )
}

export default PricingSection